// @ts-nocheck
import { useState } from "react";
import { Button, Flex, Space } from "antd";
import { EditOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";
import InfoDisplay from "./infoDisplay.js";
import InfoEdit from "./infoEdit.js";
import OTPModal from "../OTPModal.js";
import useUser from "../../hooks/useUser";
import Card from "../Card.js";

const InfoCard = () => {
  const { data, isLoading: loading, mutate } = useUser();
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  

  const refreshData = () => {
    mutate();
  };

  if (loading) return null;

  const needCompletion = !data?.phoneNumber ||
    !data?.information?.nationalCode;


  const actions = !isEditing && (
    <Flex gap={4}>
      <Button
        type={needCompletion ? "primary" : "default"}
        onClick={() => setIsEditing(true)} size="small" icon={<EditOutlined />}>
        {needCompletion ? "تکمیل اطلاعات" : "ویرایش"}
      </Button>
      {!data.isPhoneVerified && data.phoneNumber && (
        <Button
          onClick={() => setIsOTPModalOpen(true)}
          size="small"
          type="primary"
          icon={<WarningOutlined />}
        >
          تایید شماره همراه
        </Button>
      )}
    </Flex>
  );

  return (
    <>
      <Card
        title="اطلاعات فردی"
        Icon={UserOutlined}
        actions={actions}
      >
        {isEditing ? (
          <InfoEdit
            onSuccess={() => {
              refreshData();
              setIsEditing(false);
            }}
            onCancel={() => setIsEditing(false)}
            data={{ ...data, ...data.information }}
          />
        ) : (
          <InfoDisplay data={{ ...data, ...data.information }} />
        )}
      </Card>
      <OTPModal
        type="PHONE_VERIFICATION"
        requestOtp
        open={isOTPModalOpen}
        onClose={() => {
          mutate();
          setIsOTPModalOpen(false);
        }}
        onSuccess={() => setIsOTPModalOpen(false)}
      />
    </>
  );
};

export default InfoCard;
